import { render } from "./overview_of_profile.html?vue&type=template&id=8b85bc72&scoped=true&external"
import script from "./overview_of_profile.js?vue&type=script&lang=js&external"
export * from "./overview_of_profile.js?vue&type=script&lang=js&external"

import "./OverviewOfProfile.vue?vue&type=style&index=0&id=8b85bc72&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b85bc72"]])

export default __exports__